// Function loadVideoListingBlock loads the VideoListingBlock class by dynamically importing the js on demand if needed

export function loadVideoListingBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-video-listing-block-chunk" */ '../widgets/videoListingBlock').then(wg => {

		const { VideoListingBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="VideoListingBlock"]');

		if(!$wg) {
			// console.info('VideoListingBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="VideoListingBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new VideoListingBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new VideoListingBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the VideoListingBlock widget');

}
